import { FaBoxes, FaIndustry, FaTrain } from "react-icons/fa";
import { PiTrainRegionalFill } from "react-icons/pi";

export const tableHead = [
  //   { head: "Action", rowSpan: 2, colSpan: 1 },
  { head: "S/N", rowSpan: 1, colSpan: 1 },
  { head: "Siding", rowSpan: 1, colSpan: 1 },
  { head: "Destination", rowSpan: 1, colSpan: 1 },
  { head: "EMBD /S.SUPPLY", rowSpan: 1, colSpan: 1 },
  { head: "LAST IRE", rowSpan: 1, colSpan: 1 },
  { head: "CMDT [PTY-B/C/D]", rowSpan: 1, colSpan: 1 },
  { head: "Wgns", rowSpan: 1, colSpan: 1 },
  { head: "update Wgns", rowSpan: 2, colSpan: 1 },
  { head: "Type", rowSpan: 1, colSpan: 1 },
  { head: "FCN NO.", rowSpan: 1, colSpan: 1 },
  { head: "FCN", rowSpan: 1, colSpan: 1 },
  { head: "Arr", rowSpan: 1, colSpan: 1 },
  { head: "Placed", rowSpan: 1, colSpan: 1 },
  { head: "ExpRdy", rowSpan: 1, colSpan: 1 },
  // { head: "ExpRdy REmark", rowSpan: 1, colSpan: 1 },
  { head: "Ready", rowSpan: 1, colSpan: 1 },
  { head: "BPC", rowSpan: 1, colSpan: 1 },
  { head: "Valid(Y/N)", rowSpan: 1, colSpan: 1 },
  { head: "Siding Dep", rowSpan: 1, colSpan: 1 },
  { head: "RL_DP", rowSpan: 1, colSpan: 1 },
  { head: "REMARKS RDY TO DEP", rowSpan: 1, colSpan: 1 },
];

export const subHead = [];

export const sidingOrder = [
  "JQSG",
  "BCSW",
  "UCLM",
  "MYR/KJS",
  "RCPB",
  "DDSG",
  "UCLT",
  "PCIH",
];
export const commodityOrder = [
  "FG",
  "RICE",
  "FERT",
  "WHEAT",
  "CONT",
  "CLKR",
  "LST",
  "LSST",
  "BAUX",
  "IORE",
  "NCOL",
  "NEUC",
  "NPBC",
  "NPHC",
  "COAL",
  "ASH",
  "F/ASH",
  "PHC",
];
export const columnOrderForDownload = [
  "siding",
  "destination",
  "embedded_supply",
  "last_ire",
  "commodity",
  "wagon_type",
  "wagons",
  "fcn_no",
  "order_date",
  "order_time",
  "arr_date",
  "arr_time",
  "placed_date",
  "placed_time",
  "exp_ready_date",
  "exp_ready_time",
  "exp_ready_remark",
  "ready_date",
  "ready_time",
  "bpc",
  "valid",
  "siding_date",
  "siding_time",
  "rl_dp",
  "remarks",
];
export const cards = [
  {
    title: "Cement",
    value: "totalCementRakes",
    color: "primary",
    border: "#0d6efd",
    bg: "#e8f2ff",
    icon: <FaBoxes className="fs-2 text-primary" />,
  },
  {
    title: "Rakes",
    value: "totalOtherRakes",
    color: "success",
    border: "#198754",
    bg: "#eaf9ef",
    icon: <FaTrain className="fs-2 text-success" />,
  },
  {
    title: "RMC",
    value: "totalRMCRakes",
    color: "danger",
    border: "#fd0d0d",
    bg: "#ffe8e9",
    icon: <PiTrainRegionalFill className="fs-2 text-danger" />,
  },
  {
    title: "Grand Total",
    value: "grandTotal",
    color: "warning",
    border: "#fd7e14",
    bg: "#fff2e8",
    icon: <FaIndustry className="fs-2 text-warning" />,
    isTotal: true,
  },
];
